import { Booking } from '../../models/booking.model';
import { DEFAULT_COMMISSION_RATE } from '../../models/user.model';

export function rentalCentsFromBooking(booking: Pick<Booking, 'bookingPriceCents' | 'totalPrice'>): number {
  const fromField = Number(booking.bookingPriceCents ?? 0);
  if (fromField > 0) return fromField;
  const total = Number(booking.totalPrice ?? 0);
  return total > 0 ? Math.round(total * 100) : 0;
}

export function isFullPaymentBooking(
  booking: Pick<Booking, 'payoutModeAtCheckout' | 'payment_status'>,
): boolean {
  return booking.payoutModeAtCheckout === 'STRIPE' || booking.payment_status === 'FULL_PAYMENT';
}

/** Amount the guest paid online at checkout (Step 1), in euros. */
export function onlineFeeEurosFromBooking(booking: Booking): number {
  const rentalCents = rentalCentsFromBooking(booking);
  if (isFullPaymentBooking(booking)) {
    return Math.round(rentalCents) / 100;
  }

  const chargedCents = Number(booking.applicationFeeCents ?? 0);
  if (chargedCents > 0) return Math.round(chargedCents) / 100;

  const grossCents = Number(booking.commissionAmountCents ?? 0);
  if (grossCents > 0) return Math.round(grossCents) / 100;

  const rate = typeof booking.commissionRateApplied === 'number'
    ? booking.commissionRateApplied
    : DEFAULT_COMMISSION_RATE;
  return Math.round(rentalCents * rate) / 100;
}

/** Balance the guest pays directly to the owner (MANUAL checkout), in euros. */
export function ownerBalanceEurosFromBooking(booking: Booking): number {
  if (isFullPaymentBooking(booking)) return 0;
  const rentalCents = rentalCentsFromBooking(booking);
  const onlineCents = Math.round(onlineFeeEurosFromBooking(booking) * 100);
  return Math.max(0, rentalCents - onlineCents) / 100;
}

export function commissionRatePercentFromBooking(
  booking: Pick<Booking, 'commissionRateApplied'>,
): number {
  const rate = typeof booking.commissionRateApplied === 'number'
    ? booking.commissionRateApplied
    : DEFAULT_COMMISSION_RATE;
  return Math.round(rate * 1000) / 10;
}
